import MortgageReportDescription from './MortgageReportDescription';
import CompSerialNumDescription from './CompSerialNumDescription';
import PaymentFileDescription from './PaymentFileDescription';
import SerialNumberDescription from './SerialNumberDescription';
import TaxBalanceDescription from './TaxBalanceDescription';

let Examples = {};

Examples['Payment File'] = <PaymentFileDescription />;
Examples['Requested Serial Number File'] = <SerialNumberDescription />;
Examples['Mortgage Delinquent Report'] = <MortgageReportDescription />;
Examples['Complete Tax Serial Number File'] = <CompSerialNumDescription />;
Examples['Tax Balance File'] = <TaxBalanceDescription />;

export default Examples;
